import { Button, Col, Row, Spin } from "antd";
import { AxiosError } from "axios";
import moment from "moment";
import { useQuery } from "react-query";
import { fetchBookable } from "../../../../../apis/This";
import useUser from "../../../../../hooks/useUsers";
import { alertError } from "../../../../../shared/utils";
import { TimeDataType } from "../../../Unbookable/Times";

interface BooksTimesProps {
  date: moment.Moment;
  time: moment.Moment | undefined;
  onChange?: (time: moment.Moment) => void;
}
/**
 * 시간 선택 정보
 * @returns
 */
export const BooksTimes: React.FC<BooksTimesProps> = ({
  date,
  time,
  onChange = () => void 0,
}) => {
  const { getUserID } = useUser();

  /**
   *  운영시간 및 예약불가 시간 조회 API
   */
  const { data, isSuccess, isLoading, isFetching } = useQuery(
    ["BookableTimes", date?.format("YYYYMMDD"), getUserID()],
    () => fetchBookable(date!.startOf("date").toISOString()),
    {
      enabled: !!date && !!getUserID(),
      refetchOnMount: "always",
      select: (data) => {
        const businessTimes = data.businessHourList.map((value) =>
          moment(value)
        );

        const bookableTimes = data.bookableBusinessHourList.map((value) =>
          moment(value)
        );

        return businessTimes.map((time, i) => {
          return {
            key: i + 1,
            time,
            disabled: !bookableTimes.find((bookableTime) =>
              bookableTime.isSame(time)
            ),
          } as TimeDataType;
        });
      },
      onError: (err: AxiosError) => {
        alertError(err.message);
      },
    }
  );
  /**
   * 시간 변경
   * @param time
   */
  const handleClick = (time: moment.Moment) => {
    onChange(time);
  };

  return (
    <Spin spinning={isLoading || isFetching}>
      <Row gutter={[4, 4]} justify="start">
        {data?.map(({ time: item, disabled }, index) => (
          <Col key={`times-${index}`} span={6}>
            <Button
              block
              size="middle"
              type={time?.isSame(item) ? "primary" : "default"}
              disabled={disabled}
              onClick={() => handleClick(item)}
              style={{ borderRadius: 6 }}
            >
              {item.format("HH:mm")}
            </Button>
          </Col>
        ))}
      </Row>
    </Spin>
  );
};
